export class CancelTracker {
  private _promise: Promise<void>;
  private _resolver!: (value: void | PromiseLike<void>) => void;

  constructor() {
    this._promise = new Promise<void>((resolve) => {
      this._resolver = resolve;
    });
  }

  public async cancelAsync(): Promise<void> {
    await this._resolver();
  }

  public when(callback: (() => void) | undefined) {
    return this._promise.then(callback);
  }
}
